<template>
  <div class="saved-view-info">
    <div class="_label">
      {{ label }}
    </div>
    <div class="_view">
      <m-icon :type="typeIcon" />
      <item-title
        :title="view.title"
        :icons="[{ value: view.emoji }]"
        class="_text"
      />
    </div>
    <m-tooltip
      v-if="isPublic"
      placement="top"
    >
      <div class="_privacy">
        <m-icon type="global" />
      </div>
      <template #title>
        {{ $t('savedViewInfo.publicTooltip') }}
      </template>
    </m-tooltip>
  </div>
</template>

<script>
import ItemTitle from '@/components/ItemTitle.vue';
import useAccess from '@/composables/access/access';
import { accessGroupFlag } from 'shared/constants.json';
import { iconByType } from '@/lib/saved-view';

export default {
  name: 'SavedViewInfo',
  props: {
    view: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { userHasRight } = useAccess();
    return { userHasRight };
  },
  components: { ItemTitle },
  computed: {
    typeIcon() {
      return iconByType(this.view.viewType);
    },
    hasPublicViewAccess() {
      return this.userHasRight([accessGroupFlag.publicSavedViews]);
    },
    isPublic() {
      return this.view.isPublic;
    },
    canEdit() {
      return !this.view.isPublic || this.hasPublicViewAccess;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .saved-view-info {
    display: flex;
    align-items: center;

    ._privacy {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: .2rem;
    }

    ._label {
      margin-right: .8rem;
    }

    ._view {
      display: flex;
      align-items: center;

      ._text {
        max-width: 15rem;
        margin-right: .8rem;
        margin-left: .6rem;
        font-weight: $font-weight-semibold;
      }
    }
  }
</style>
